import { useMissionsTranslation } from '../../../../ui/hooks';
import React from 'react';
import { ShiftSelect } from '../../shift-details/components/past-shifts/ShiftSelect';
export const SelectShiftStep = React.forwardRef((props, ref) => {
    var _a, _b, _c, _d, _e, _f;
    const { t } = useMissionsTranslation();
    const [selectedShift, setSelectedShift] = React.useState((_b = (_a = props.data) === null || _a === void 0 ? void 0 : _a.shift) === null || _b === void 0 ? void 0 : _b.id);
    const [selectedPosition, setSelectedPosition] = React.useState((_c = props.data) === null || _c === void 0 ? void 0 : _c.position);
    const handleShiftChange = (selectedShift) => {
        setSelectedShift(selectedShift);
        setSelectedPosition(undefined);
    };
    React.useImperativeHandle(ref, () => ({
        getData: () => ({ shift: { id: selectedShift } }),
        submit: () => {
            if (selectedShift) {
                return props
                    .onSubmit({ shift: { id: selectedShift } })
                    .then((response) => props.onSubmitSuccess({ shift: { id: selectedShift }, position: selectedPosition }, response));
            }
            else {
                return Promise.reject(t('shiftVolunteerManagementWizard.validation.shiftNotSelected'));
            }
        },
    }));
    return (React.createElement(ShiftSelect, { title: t('shiftVolunteerManagementWizard.titles.selectShiftForPosition'), additionalShiftFilters: props.additionalShiftFilter, onChange: handleShiftChange, value: (_f = selectedShift !== null && selectedShift !== void 0 ? selectedShift : (_e = (_d = props.data) === null || _d === void 0 ? void 0 : _d.shift) === null || _e === void 0 ? void 0 : _e.id) !== null && _f !== void 0 ? _f : '' }));
});
